<template>
  <div class="container">
    <div class="vz-page-cookies">
      <div class="vz-page-cookies-title">Положение</div>
      <div>о политике в отношении обработки cookie-файлов</div>
      <a
        class="vz-page-cookies-button"
        target="_blank"
        href="/cookie.pdf"
        download
      >
        <img
          class="vz-page-cookies-button-img"
          src="../assets/icons/file-document.svg"
          alt=""
        >
        PDF
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage'
}
</script>

<style scoped>
.container {
  width: 97%;
  max-width: 1240px;
  padding-top: 25px;
  padding-bottom: 25px;
  display: flex;
  align-items: center;
  margin: auto;
}
</style>

<style>
.vz-page-cookies {
  margin-top: 40px;
  margin-bottom: 40px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 6px;
}

.vz-page-cookies-title {
  color: #333;
  font-weight: 500;
}

.vz-page-cookies-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ff3131;
  margin-top: 24px;
  color: white;
  height: 38px;
  padding: 0 16px;
  border-radius: 4px;
  width: fit-content;
  text-decoration: unset;
  opacity: 1;
  transition: opacity 150ms ease-in-out;
}

.vz-page-cookies-button-img {
  width: 16px;
  height: 16px;
}

.vz-page-cookies-button:hover {
  text-decoration: unset;
  opacity: 0.9;
  color: #fff;
}
</style>
